import React from 'react';
import AccordionDetails from '@mui/material/AccordionDetails';
import PaymentDetailsMyAccounts from 'app/components/AccordionTypes/MyAccounts/PaymentDetailsMyAccounts';
import PaymentDetailsInBank from 'app/components/AccordionTypes/InBank/PaymentDetailsInBank';
import PaymentDetailsCredit from 'app/components/AccordionTypes/Credit/PaymentDetailsCredit';
import PaymentDetailsAbroad from 'app/components/AccordionTypes/Abroad/PaymentDetailsAbroad';
import PaymentDetailsEDV from 'app/components/AccordionTypes/EDV/PaymentDetailsEDV';
import PaymentDetailsBudget from 'app/components/AccordionTypes/Budget/PaymentDetailsBudget';
import PaymentDetailsCountry from 'app/components/AccordionTypes/Country/PaymentDetailsCountry';
import { SelectProps } from 'app/constants/types';
import GeneralDetailsConversion from 'app/components/AccordionTypes/Conversion/GeneralDetailsConversion';

interface DetailsProps {
  type: string;
  value?: SelectProps | null;
  accountOptions?: any;
  selectedFromAccount?: any;
  onChangeFromAccount?: (value: any) => void;
  control?: any;
  register?: any;
  errors?: any;
  onChangeCommission?: any;
  selectedCommission?: any;
  fromAccountConversion?: any;
  toAccountConversion?: any;
  handleChangeFromConversion?: any;
  handleChangeToConversion?: any;
  selectedFromAccountConversion?: any;
  selectedToAccountConversion?: any;
  commissionConversion?: any;
  handleChangeCommissionConversion?: any;
  checkIndividualConversion?: any;
  handleSwitchIndividualConversion?: any;
  rates?: any;
  selectedRates?: any;
  handleSelectRates?: any;
  fromAmountConversion?: any;
  toAmountConversion?: any;
  handleChangeFromAmountConversion?: any;
  handleChangeToAmountConversion?: any;
  handleSwitchCurrencyConversion?: any;
  dataForm?: any;
  onChangeAmount?: any;
  amount?: any;
  commissionOption?: any;
  individualRates?: any;
  handleChangeIndividualRate?: any;
}

const PaymentDetails = (props: DetailsProps) => {
  const {
    type,
    value,
    accountOptions,
    onChangeFromAccount,
    selectedFromAccount,
    register,
    control,
    errors,
    selectedCommission,
    onChangeCommission,
    fromAccountConversion,
    toAccountConversion,
    handleChangeFromConversion,
    handleChangeToConversion,
    selectedFromAccountConversion,
    handleChangeCommissionConversion,
    handleSwitchIndividualConversion,
    checkIndividualConversion,
    selectedToAccountConversion,
    commissionConversion,
    rates,
    selectedRates,
    handleSelectRates,
    fromAmountConversion,
    toAmountConversion,
    handleChangeFromAmountConversion,
    handleChangeToAmountConversion,
    handleSwitchCurrencyConversion,
    dataForm,
    onChangeAmount,
    amount,
    commissionOption,
    individualRates,
    handleChangeIndividualRate,
  } = props;

  return (
    <AccordionDetails sx={{ padding: '0px 28px 32px' }}>
      {type === 'payment_acc2acc' && (
        <PaymentDetailsMyAccounts
          accountOptions={accountOptions}
          selectedFromAccount={selectedFromAccount}
          onChangeFromAccount={onChangeFromAccount}
          control={control}
          register={register}
          errors={errors}
          dataForm={dataForm}
          onChangeAmount={onChangeAmount}
          amount={amount}
        />
      )}
      {type === 'payment_interbank' && (
        <PaymentDetailsInBank
          accountOptions={accountOptions}
          selectedFromAccount={selectedFromAccount}
          onChangeFromAccount={onChangeFromAccount}
          control={control}
          register={register}
          errors={errors}
          dataForm={dataForm}
          onChangeAmount={onChangeAmount}
          amount={amount}
        />
      )}
      {type === 'payment_local_transfer' && (
        <PaymentDetailsCountry
          value={value}
          accountOptions={accountOptions}
          selectedFromAccount={selectedFromAccount}
          onChangeFromAccount={onChangeFromAccount}
          control={control}
          register={register}
          errors={errors}
          selectedCommission={selectedCommission}
          onChangeCommission={onChangeCommission}
          dataForm={dataForm}
          onChangeAmount={onChangeAmount}
          amount={amount}
          commissionOption={commissionOption}
        />
      )}
      {type === 'payment_foreign_transfer' && (
        <PaymentDetailsAbroad
          control={control}
          register={register}
          errors={errors}
          accountOptions={accountOptions}
          selectedFromAccount={selectedFromAccount}
          onChangeFromAccount={onChangeFromAccount}
          selectedCommission={selectedCommission}
          onChangeCommission={onChangeCommission}
          onChangeAmount={onChangeAmount}
          amount={amount}
          commissionOption={commissionOption}
        />
      )}
      {type === 'payment_edv' && (
        <PaymentDetailsEDV
          accountOptions={accountOptions}
          selectedFromAccount={selectedFromAccount}
          onChangeFromAccount={onChangeFromAccount}
          control={control}
          register={register}
          errors={errors}
          selectedCommission={selectedCommission}
          onChangeCommission={onChangeCommission}
          dataForm={dataForm}
          onChangeAmount={onChangeAmount}
          amount={amount}
          commissionOption={commissionOption}
        />
      )}
      {type === 'payment_budget' && (
        <PaymentDetailsBudget
          accountOptions={accountOptions}
          selectedFromAccount={selectedFromAccount}
          onChangeFromAccount={onChangeFromAccount}
          control={control}
          register={register}
          errors={errors}
          selectedCommission={selectedCommission}
          onChangeCommission={onChangeCommission}
          dataForm={dataForm}
          onChangeAmount={onChangeAmount}
          amount={amount}
          commissionOption={commissionOption}
        />
      )}
      {type === 'payment_conversion' && (
        <GeneralDetailsConversion
          control={control}
          register={register}
          errors={errors}
          fromAccountConversion={fromAccountConversion}
          toAccountConversion={toAccountConversion}
          handleChangeFromConversion={handleChangeFromConversion}
          handleChangeToConversion={handleChangeToConversion}
          selectedFromAccountConversion={selectedFromAccountConversion}
          selectedToAccountConversion={selectedToAccountConversion}
          handleChangeCommissionConversion={handleChangeCommissionConversion}
          handleSwitchIndividualConversion={handleSwitchIndividualConversion}
          checkIndividualConversion={checkIndividualConversion}
          commissionConversion={commissionConversion}
          rates={rates}
          selectedRates={selectedRates}
          handleSelectRates={handleSelectRates}
          handleChangeFromAmountConversion={handleChangeFromAmountConversion}
          fromAmountConversion={fromAmountConversion}
          toAmountConversion={toAmountConversion}
          handleChangeToAmountConversion={handleChangeToAmountConversion}
          handleSwitchCurrencyConversion={handleSwitchCurrencyConversion}
          dataForm={dataForm}
          commissionOption={commissionOption}
          individualRates={individualRates}
          handleChangeIndividualRate={handleChangeIndividualRate}
        />
      )}
      {type === 'credit' && <PaymentDetailsCredit />}
    </AccordionDetails>
  );
};

export default PaymentDetails;
